import { useEffect } from "react";

interface FaviconHandlerProps {
    url: string;
}

export const FaviconHandler = ({ url }: FaviconHandlerProps) => {
    useEffect(() => {
        let link: HTMLLinkElement | null = document.querySelector("link[rel~='icon']");

        if (!link) {
            link = document.createElement("link");
            link.rel = "icon";
            document.head.appendChild(link);
        }

        link.href = url;
    }, [url]);

    return null;
};
